import { depascalize, DropdownOption } from "sprint-common-web";

import { OrderProxyType } from "./OrderProxyType";

export type OrderAudioProxyType = typeof orderAudioProxyTypes[number];

export const orderAudioProxyTypes = [
    OrderProxyType.Aac128k,
    OrderProxyType.Aac48k,
    OrderProxyType.Mp2,
    OrderProxyType.AacFdk128k,
    OrderProxyType.AacFdk48k,
    OrderProxyType.AacFdkHev264k,
    OrderProxyType.Mp2_128k48,
    OrderProxyType.AacFdk128k48
] as const;

export const orderAudioProxyTypeDropdownOptions = orderAudioProxyTypes.map<DropdownOption>((type) => ({
    key: type.toString(),
    text: depascalize(OrderProxyType[type])
}));

export const mapToOrderAudioProxyType = (type: number | string): OrderAudioProxyType => {
    const proxyType = orderAudioProxyTypes.find((proxy: OrderAudioProxyType) => proxy === Number(type));

    if (proxyType === undefined) {
        throw new Error("Incorrect OrderAudioProxyType");
    }

    return proxyType;
};
